export default function ($el) {
  $el.on('click', (event) => {
    event.preventDefault();
    if ($el.hasClass('disabled')) return;
    if ($el.data('disabled')) return;

    const isInvisible =
      $($el.data('element'))
        .attr('class')
        .indexOf('invisible absolute opacity-0') > -1;

    if (isInvisible) {
      $($el.data('element')).removeClass('invisible absolute opacity-0');
      $($el.data('element')).addClass('opacity-1');
    } else {
      $($el.data('element')).toggleClass('hidden');
    }

    if ($el.data('element-to-hide-when-this-one-is-shown')) {
      if (isInvisible) {
        $($el.data('element-to-hide-when-this-one-is-shown')).removeClass(
          'opacity-1'
        );
        $($el.data('element-to-hide-when-this-one-is-shown')).addClass(
          'invisible absolute opacity-0'
        );
      } else {
        $($el.data('element-to-hide-when-this-one-is-shown')).addClass(
          'hidden'
        );
      }
    }

    if ($el.data('enable-when-clicked')) {
      $el.addClass('disabled');
      $($el.data('enable-when-clicked')).removeClass('disabled');
    }

    if ($el.data('toggle-chevron')) {
      if ($el.hasClass('open')) {
        $el.removeClass('open');
      } else {
        $el.addClass('open');
      }
    }
  });
}
